<template>
  <v-col class="" cols="12" xs="12" sm="6" md="3">

    <v-card @click="mostrarDialogo = true">
      <v-card-title>       {{ infoAlmacen.NOMBRE }} </v-card-title>
      <v-card-text> Folio: {{ infoAlmacen.FOLIO }} </v-card-text>
    </v-card>

    <v-dialog v-model="mostrarDialogo" transition="dialog-bottom-transition" fullscreen>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="mostrarDialogo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ infoAlmacen.ALMACEN_ID }} {{ infoAlmacen.NOMBRE }}</v-toolbar-title>
          <v-spacer/>
          <v-toolbar-items> salir </v-toolbar-items>
        </v-toolbar>
      </v-card>
    </v-dialog>

  </v-col>
</template>

<script>
export default {

  props: ["infoAlmacen"],

  data() {
    return {

      mostrarDialogo: false,

    };
  },

  created() {
    this.mostrarDialogo = false;
  },
  
};
</script>

<style></style>
